import * as React from 'react';
import { useEffect, useState } from 'react';
import { Card, CardTitle, Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, getSelectedAfr } from '../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import { getTaxonomyType } from '../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { UserRoleEnum } from '../../redux/UserSlice';
import utilityHelper from '../../utils/utilityHelper';
import AdminComment from '../feature/AdminComment';
import AuditorRequestManager from '../feature/AuditorRequestManager';
import BypassRequest from '../feature/BypassRequest';
import DocumentList from '../feature/DocumentList';
import EventList from '../feature/EventList';
import SummaryAdministrationTab from '../feature/SummaryAdministrationTab';
import Page from '../Page';

const InstructionsCore = (props: { userRole: string, dataSection: string }) => {
    const dispatch = useAppDispatch();
    const [activeTab, setActiveTab] = useState("1");

    const toggle = (tab: any) => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const activeClass = (tab: any) => {
        return (tab === activeTab) ? "active" : "";
    }
    var introHTML = "<h1 class=\"Instructions-first-line\" ><span style='font-family:\"Times New Roman\",serif'>Statement of County " +
        "Funded Court-Related Functions Report</span></h1 > " +

        "<h1 class=\"Instructions\" ><span style='font-family:\"Times New Roman\",serif'>Pursuant to Section " +
        "29.0085, Florida Statutes</span></h1 > " +

        "<p class=\"MsoNoSpacing\">&nbsp;</p> " +

        "<p class=\"MsoNormal\" style='margin-bottom:0in'><span class=\"MsoIntenseEmphasis\"><span " +
        "style='font-family:\"Times New Roman\",serif' > Overview</span></span></p> " +

        "<p class=\"MsoNormal\"><span style='line-height:107%;font-family:\"Times New Roman\",serif'>Florida " +
        "Statute 29.0085 requires a Statement of Revenues and Expenditures of county " +
        "funded court-related functions to be submitted <span class=\"text\"><span " +
        "style='color:black' > within 4 months (January 31<sup>st</sup>) of the close of " +
        "the local government fiscal year (September 30<sup>th</sup>). Each county shall " +
        "also submit to the Chief Financial Officer (CFO) a statement of compliance from " +
        "its independent certified public accountant, pursuant to Section 218.39, F.S., " +
        "that the certified statement of expenditures is in accordance with Sections </span></span></span> <a " +
        "href=\"http://www.leg.state.fl.us/statutes/index.cfm?App_mode=\"Display_Statute&amp;Search_String=29.0085&amp;URL=0000-0099/0029/Sections/0029.008.html\"\" target=\"self\" title=\"Link to 29.008 Statutes\"><span " +
        "style='line-height:107%;font-family:\"Times New Roman\",serif;color:black; " +
        "text-decoration:none'>29.008</span></a><span class=\"text\"><span style='line-height: " +
        "107%; font-family: \"Times New Roman\",serif;color:black'> and 29.0085, F.S. All " +
        "discrepancies noted by the independent certified public accountant shall be " +
        "included in the statement furnished by the county to the CFO.</span></span> <span " +
        "style='line-height:107%;font-family:\"Times New Roman\",serif' > To meet the 4-month requirement, each county will upload the report (Excel format) and the statement of compliance (PDF format) to LOGERx and certify it by January 31st.</p> ";

    var Ahtml = "<h2 class=\"Instructions\" style='margin-top:0in'><span style='font-family:\"Times New Roman\",serif'>Part " +
        "A – Statement of Revenues for Court-Related Functions</span></h2>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in'><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></p>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in;line-height:normal'><span " +
        "style='font-family:\"Times New Roman\",serif'>The Statement of Revenue balances " +
        "are comprised of funds collected by way of Local Requirements adopted by the " +
        "County Commissions and monies dedicated to funding-approved programs (see " +
        "below). The balances are posted to the Local Requirements reporting entity " +
        "column of the DFS-A6-693 form. This Statement should reflect fiscal year collections " +
        "from various sources that are used to fund authorized (by statute, local " +
        "ordinance, and/or court order) programs defined as Local Requirements, per Section " +
        "29.0085(2)(a), F.S. The various sources of revenue include, but are not limited " +
        "to:</span></p>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in;text-align:justify;text-justify:" +
        "inter-ideograph;line-height:normal'><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></p>" +
        "<p class=\"MsoListParagraphCxSpFirst\" style='text-indent:-.25in'><span " +
        "style='font-family:\"Times New Roman\",serif'>1)<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
        "</span></span><span style='font-family:\"Times New Roman\",serif'>Local " +
        "collections of Board-adopted additional court costs and ordinances such as " +
        "those prescribed in Section 939.185, F.S., ($65) and the (up to) $30 surcharge " +
        "used to fund state court facilities, per Section 318.18(13)(a), F.S.</span>;</p>" +
        "<p class=\"MsoListParagraphCxSpMiddle\" style='text-indent:-.25in'><span " +
        "style='font-family:\"Times New Roman\",serif'>2)<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
        "</span></span><span style='font-family:\"Times New Roman\",serif'>Court Cost " +
        "collection of $2.00 revenue per Section 28.24(12)(e)(1), F.S., dedicated to " +
        "fund court related IT equipment;</span></p>" +
        "<p class=\"MsoListParagraphCxSpMiddle\" style='text-indent:-.25in'><span " +
        "style='font-family:\"Times New Roman\",serif'>3)<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
        "</span></span><span style='font-family:\"Times New Roman\",serif'>Federal, State, " +
        "and Local grants restricted to funding Local Requirements programs;</span></p>" +
        "<p class=\"MsoListParagraphCxSpLast\" style='margin-bottom:0in;text-indent:-.25in'><span" +
        "style='font-family:\"Times New Roman\",serif'>4)<span style='font:7.0pt \"Times New Roman\"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
        "</span></span><span style='font-family:\"Times New Roman\",serif'>Monies " +
        "collected from various service charges in the process of conducting Local " +
        "Requirements business. For example, service charges and late fees collected by " +
        "the Law Library.</span></p>";

    var Bhtml = "<h2 class=\"Instructions\" ><span style='font-family:\"Times New Roman\",serif'>Part B – Non-Reoccurring " +
        "Fixed Capital Outlay (FCO) Expenditures</span></h2>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in'><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></p>" +
        "<p class=\"Instructions\"><span style='font-family:\"Times New Roman\",serif'>Expenditure " +
        "balances that have funded large dollar, fixed capital outlay projects are to be " +
        "reported as “non-reoccurring” costs. The balances to report are funded with " +
        "county dollars, not those that may have been received from the state or federal " +
        "grants.</p><p class=\"Instructions\">The two most common capital outlay project areas are facility " +
        "construction or reconstruction projects and communication network infrastructure " +
        "overhauls. These two options have been listed separately to capture the " +
        "non-reoccurring costs associated with these specific FCO project areas. In " +
        "addition, please add line items to isolate any county funded purchase of " +
        "permanent facility improvements, such as furniture essential to the daily " +
        "operations of the court system, real estate, easements and parking improvements " +
        "for such facilities that are essential in carrying out court-related functions.</p>" +
        "<p class=\"Instructions\">There is also an “Other” option to record capital projects that do not fall " +
        "into these areas. The primary criteria for recording any expenditure balance in " +
        "Part B is they are not considered re-occurring, operating expenditures. This " +
        "section is designed to remove non-reoccurring costs from the county’s " +
        "operational expenditure balances that are required to be increased by 1.5 " +
        "percent each fiscal year pursuant Section 29.0085, F.S. (see statutory " +
        "requirement).</span></p>" +
        "<p class=\"MsoNoSpacing\"><span class=\"MsoIntenseEmphasis\"><span style='font-family:" +
        "\"Times New Roman\",serif'>&nbsp;</span></span></p>" +
        "<p class=\"MsoNormal\" style='text-align:justify;text-justify:inter-ideograph'><span " +
        "class=\"MsoIntenseEmphasis\"><span style='font-family:\"Times New Roman\",serif'>Statutory " +
        "Requirement</span></span></p>" +
        "<p class=\"MsoNormal\"><span style='font-family:\"Times New Roman\",serif'>Pursuant " +
        "to Section 29.008(4)(a), F.S., expenditures for fiscal year 2015-2016 in each " +
        "item in “Facility Cost”, the total of “Communication Systems and Services”, " +
        "“Existing Radio Systems”, and “Existing Multi-Agency Criminal Justice Information " +
        "Systems” in Part C must be increased by 1.5 percent from the 2014-2015 fiscal " +
        "year balances. </span></p>" +
        "<p class=\"MsoNoSpacing\"><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></p>";

    var Chtml = "<h2 class=\"Instructions\" ><span style='font-family:\"Times New Roman\",serif'>Part C – Statement of " +
        "Expenditures for County Funded Court–Related Functions</span></h2>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in;text-align:justify;text-justify:" +
        "inter-ideograph'><span style='font-size:14.0pt;line-height:107%;font-family:" +
        "\"Times New Roman\",serif'>&nbsp;</span></p>" +
        "<p class=\"MsoNormal\" style='text-align:justify;text-justify:inter-ideograph'><span " +
        "class=\"MsoIntenseEmphasis\"><span style='font-family:\"Times New Roman\",serif'>Reporting " +
        "Entities</span></span></p>" +
        "<p class='Instructions'>The " +
        "expenditures reported will comprise the county's total expenditure balance dedicated " +
        "to funding the court related functions specified as the County’s responsibility " +
        "in Section 29.008, F.S. Where applicable, the expenditures should be dedicated " +
        "to the reporting entity that the county’s payment was made for. The entities " +
        "include the State Attorney, Public Defender, the State Courts (Circuit and " +
        "County combined), the Clerk of Circuit Courts (in performing court related " +
        "functions) and the Guardian Ad Litem (GAL). <b></p><p class='Instructions'>NOTE:</b> If the County has any " +
        "court-related expenditure funding the Regional Conflict Courts, these balances " +
        "should be included in the Public Defender column of the report. In the case of " +
        "a lump sum expenditure balance for the year that is on behalf of all (or more " +
        "than one) of the reporting entities, an allocation method should be used. The " +
        "allocation should reflect the entire cost for a single expenditure category line " +
        "item and have a notation of which reporting entities comprise the total " +
        "balance. There should also be a description of the method used. For example, " +
        "the office lease of the courtroom facility is allocated by square foot between " +
        "the State Court’s office space (court rooms, hearing rooms, judges’ chambers, " +
        "etc.), the State Attorney’s office space, Public Defender’s office space, and " +
        "the Clerk of Circuit Courts’ office space.</span></p>" +
        "<p class=\"MsoNormal\"><span class=\"MsoIntenseEmphasis\"><span style='font-family:" +
        "\"Times New Roman\",serif'>Expenditure Category Items</span></span></p>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in'><span style='font-family:\"Times New Roman\",serif'>Pursuant " +
        "to Section 29.008, F.S., counties are statutorily required to fund the cost of " +
        "explicit expenditure category items on behalf of the State Court system, comprised " +
        "of each of the above Reporting Entities. These categories are <span " +
        "class=\"QuoteChar\">“Facility Cost”, “Communications Cost”, “Existing Radio System " +
        "Cost”, “Existing Multi-Agency Criminal Justice Information System Cost”, “Cost " +
        "of Local Requirements” (Part D of the DFS-A6-693) and “Other County-Funded " +
        "Court Related Expenditures” (Part E of the DFS-A6-693).</span>  Furthermore, " +
        "these expenditure categories are listed on the DFS-A6-693 form and upon " +
        "inputting the applicable expenditure balances for each they will automatically " +
        "sum the sub total and grand total lines.</span></p>" +
        "<p class=\"MsoNoSpacing\"><span class=\"MsoIntenseEmphasis\"><span style='font-family:" +
        "\"Times New Roman\",serif'>&nbsp;</span></span></p>" +
        "<p class=\"MsoNormal\" style='text-align:justify;text-justify:inter-ideograph'><span " +
        "class=\"MsoIntenseEmphasis\"><span style='font-family:\"Times New Roman\",serif'>{For " +
        "Facility Cost Expenditure Category}</span></span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:.75in;text-align:justify;text-justify: " +
        "inter-ideograph'><b><span style='font-family:\"Times New Roman\",serif'>“Lease / " +
        "Rent” </span></b><span style='font-family:\"Times New Roman\",serif'>includes, " +
        "but is not limited to, all reasonable and necessary costs of the lease of " +
        "facilities housing all judicial officers, judicial staff, jurors, volunteers of " +
        "a tenant agency, and the public for each of the above Reporting Entities. Include " +
        "the lease cost of facilities used for housing legal materials, equipment or " +
        "functions used by the public and personnel of the circuit and county courts. Also " +
        "include any reoccurring expense related to financing such facilities and the " +
        "existing and future cost and bonded indebtedness associated with placing the " +
        "facilities in use.</span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:.75in;text-align:justify;text-justify:" +
        "inter-ideograph'><b><span style='font-family:\"Times New Roman\",serif'>\“Maintenance\” " +
        "</span></b><span style='font-family:\"Times New Roman\",serif'>includes, but is " +
        "not limited to, all reasonable and necessary costs of custodial and grounds " +
        "keeping services, renovation and reconstruction as needed, and maintaining the " +
        "facilities in a condition appropriate and safe for the use intended.</span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'>“Utilities”</span></b><span " +
        "style='font-family:\"Times New Roman\",serif'> means all electricity services for " +
        "light, heat, and power; natural or manufactured gas services for light, heat, " +
        "and power; water and wastewater services and systems, storm water or runoff " +
        "services and systems, sewer services and systems, all costs or fees associated " +
        "with these services and systems, and any costs or fees associated with the " +
        "mitigation of environmental impacts directly related to the facility.</span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'> “Security”</span></b><span " +
        "style='font-family:\"Times New Roman\",serif'> includes, but is not limited to, " +
        "all reasonable and necessary costs of services of law enforcement officers or " +
        "licensed security guards and all electronic, cellular, or digital monitoring " +
        "and screening devices necessary to ensure the safety and security of all " +
        "persons visiting or working in a facility; to provide for security of the " +
        "facility, including protection of property owned by the county or the state; " +
        "and for the security of prisoners brought to any facility. This includes " +
        "bailiffs while providing courtroom and other security for each judge and other " +
        "quasi-judicial officers.</span></p>" +
        "<p class=\"MsoNormal\" style='margin-top:0in;margin-right:0in;margin-bottom:0in;" +
        "margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'>“Other”</span></b><span " +
        "style='font-family:\"Times New Roman\",serif'> means all indirect costs that are " +
        "not directly accountable for in the above cost expenditure categories.</span></p>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in;text-align:justify;text-justify:" +
        "inter-ideograph'><b><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></b></p>" +
        "<p class=\"MsoNormal\" style='text-align:justify;text-justify:inter-ideograph'><span " +
        "class=\"MsoIntenseEmphasis\"><span style='font-family:\"Times New Roman\",serif'>{For " +
        "Communications Cost Expenditure Category}</span></span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'> “Telephone " +
        "Expense”</span></b><span style='font-family:\"Times New Roman\",serif'> includes, but is not limited to, " +
        "the cost of providing a carrier for local and long-distance services, including " +
        "those to cover cellular phones, used solely for those employees carrying out " +
        "court-related business. This also includes toll charges for local and long-distance " +
        "services. </span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'>“Computer " +
        "Equipment / Networks” </span></b><span style='font-family:\"Times New Roman\",serif'>" +
        "includes, but is not limited to, the purchase cost of a personal computer, server, or networking " +
        "hardware. This also includes the cost of court-related software and required " +
        "licenses purchased by any of the above Reporting Entities. </span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'>“Courier " +
        "/ Subpoena Services” </span></b><span style='font-family:\"Times New Roman\",serif'>does<b> " +
        "NOT </b>include the cost of postage and/or postage meters which has shifted to " +
        "a State funding requirement.<b> </b></span></p>" +
        "<p class=\"MsoNormal\" style='margin-top:0in;margin-right:0in;margin-bottom:0in;" +
        "margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'>“Auxiliary " +
        "Aids”</span></b><span style='font-family:\"Times New Roman\",serif'> includes, but is not limited to, " +
        "real time transcription services and assistive listening devices. </span></p>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in;text-align:justify;text-justify:" +
        "inter-ideograph'><b><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></b></p>" +
        "<p class=\"MsoNormal\" style='text-align:justify;text-justify:inter-ideograph'><span " +
        "class=\"MsoIntenseEmphasis\"><span style='font-family:\"Times New Roman\",serif'>{For " +
        "Existing Radio Systems Cost Expenditure Category}</span></span></p>" +
        "<p class=\"MsoNormal\" style='margin-top:0in;margin-right:0in;margin-bottom:0in;" +
        "margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'>“Existing " +
        "Radio Systems” </span></b><span style='font-family:\"Times New Roman\",serif'>" +
        "includes, but is not limited to, law enforcement radio systems that are used by " +
        "the above Reporting Entities.</span></p>" +
        "<p class=\"MsoNoSpacing\"><span class=\"MsoIntenseEmphasis\"><span style='font-family:" +
        "\"Times New Roman\",serif'>&nbsp;</span></span></p>" +
        "<p class=\"MsoNormal\"><span class=\"MsoIntenseEmphasis\"><span style='font-family:" +
        "\"Times New Roman\",serif'>{For Existing Multi-Agency Criminal Justice Systems " +
        "Cost Expenditure Category}</span></span></p>" +
        "<p class=\"MsoNormal\" style='margin-top:0in;margin-right:0in;margin-bottom:0in;" +
        "margin-left:.75in'><b><span style='font-family:\"Times New Roman\",serif'>“Existing " +
        "Multi-Agency Criminal Justice Information Systems”</span></b><span " +
        "style='font-family:\"Times New Roman\",serif'> includes, but is not limited to, " +
        "components of the multi-agency criminal justice information system as defined " +
        "in Section 943.045, F.S. Included are upgrades and maintenance costs of such an " +
        "existing system.</span></p>" +
        "<p class=\"MsoNoSpacing\"><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></p>";

    var Dhtml = "<h2 class=\"Instructions\" ><span style='font-family:\"Times New Roman\",serif'>Part D – Local " +
        "Requirements </span></h2>" +
        "<p class=\"MsoNormal\" style='margin-bottom:0in'><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></p>" +
        "<p class=\"MsoNormal\" style='text-align:justify;text-justify:inter-ideograph'><span " +
        "class=\"MsoIntenseEmphasis\"><span style='font-family:\"Times New Roman\",serif'>Statutory " +
        "Requirement</span></span></p>" +
        "<p class=\"MsoNormal\"><span style='font-family:\"Times New Roman\",serif'>Pursuant " +
        "to Section 29.008(4) (a), F.S., report the expenditure balances posted for each " +
        "and all other Local Requirements programs defined as:</span></p>" +
        "<p class='Instructions'>“those expenditures to fund specialized programs, non-judicial staff, and other " +
        "expenses associated with specialized court programs, specialized prosecution " +
        "needs, specialized defense needs, or resources required of a local jurisdiction " +
        " as a result of special factors or circumstances as defined in Section 29.008(2)(a), " +
        "F.S., and which have been adopted by the applicable Board of County " +
        "Commissioners after being submitted by the circuit chief judge as a tentative " +
        "budget request.” </span></p>" +
        "<p class=\"MsoNormal\"><span style='font-family:\"Times New Roman\",serif'>These Local " +
        "Requirements costs should be allocated among the appropriate Reporting Entities, " +
        "if possible.  If the Local Requirements aren’t clearly defined as a cost to one " +
        "of the Reporting Entities, the amounts should be recorded in the Local " +
        "Requirements column.</span></p>";

    var Ehtml = "<h2 class=\"Instructions\" ><span style='font-family:\"Times New Roman\",serif'>Part E – Other Court " +
        "Related Expenditures</span></h2>" +
        "<p class=\"MsoNoSpacing\"><span style='font-family:\"Times New Roman\",serif'>&nbsp;</span></p>" +
        "<p class=\"MsoNormal\" style='margin-left:58.3pt;text-indent:-.25in'><b><span " +
        "style='font-family:\"Times New Roman\",serif'>     “Other County-Funded Court " +
        "Related Expenditures” </span></b><span style='font-family:\"Times New Roman\",serif'>includes " +
        "non-statutorily required county funded court-related expenditures (i.e., health " +
        "benefits, personnel, office supplies, and other operating expenditures) " +
        "allocated among each of the Reporting Entities. This section is intended " +
        "to provide the reporting of county support to the state court system over and "                                                                                                                                                +
        "above that required by Section 29.008, F.S.  The costs do not include those " +
        "dedicated to funding Local Requirements programs.</span></p>";



    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const taxType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);
    var importLabel = "";
    var downloadTemplateLabel = "";
    switch (taxType) {
        case "COURT_REPORTING_939":
            importLabel = "Click here to upload the Court Reporting 939.185 Spreadsheet";
            downloadTemplateLabel = "Download a Court Reporting 939.185 Data Template";
            break;

        case "COURT_REPORTING_29":
            importLabel = "Click here to upload the Court Reporting 29.0085 Spreadsheet";
            downloadTemplateLabel = "Download a Court Reporting 29.0085 Data Template";
            break;
    }

    useEffect(function () {
        if (props.userRole === "ADMIN") {
            setActiveTab("4");
        }
    }, [])

    return (
        <React.Fragment>
            {currentAfr != null && entity != null ?
                <Page>
                    <h2>{utilityHelper.getTaxonomyDescriptor(taxType)}, {props.dataSection} for {entity.name} ({entity.code}), {utilityHelper.getAfrYearDescriptor(currentAfr)}</h2>
                    <div>
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={activeClass('1')}
                                    onClick={() => { toggle('1'); }}
                                >
                                    Introduction
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeClass('2')}
                                    onClick={() => { toggle('2'); }}
                                >
                                    Part A
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeClass('3')}
                                    onClick={() => { toggle('3'); }}
                                >
                                    Part B
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeClass('4')}
                                    onClick={() => { toggle('4'); }}
                                >
                                    Part C
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeClass('5')}
                                    onClick={() => { toggle('5'); }}
                                >
                                    Part D
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={activeClass('6')}
                                    onClick={() => { toggle('6'); }}
                                >
                                    Part E
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="1">
                                <Row>
                                    <Col>
                                        <Card body>
                                            <div dangerouslySetInnerHTML={{ __html: "<div>" + introHTML + "</div>" }} ></div>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="2">
                                <Row>
                                    <Col>
                                        <Card body>
                                            <div dangerouslySetInnerHTML={{ __html: "<div>" + Ahtml + "</div>" }} ></div>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="3">
                                <Row>
                                    <Col>
                                        <Card body>
                                            <div dangerouslySetInnerHTML={{ __html: "<div>" + Bhtml + "</div>" }} ></div>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="4">
                                <Row>
                                    <Col>
                                        <Card body>
                                            <div dangerouslySetInnerHTML={{ __html: "<div>" + Chtml + "</div>" }} ></div>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="5">
                                <Row>
                                    <Col>
                                        <Card body>
                                            <div dangerouslySetInnerHTML={{ __html: "<div>" + Dhtml + "</div>" }} ></div>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                            <TabPane tabId="6">
                                <Row>
                                    <Col>
                                        <Card body>
                                            <div dangerouslySetInnerHTML={{ __html: "<div>" + Ehtml + "</div>" }} ></div>
                                        </Card>
                                    </Col>
                                </Row>
                            </TabPane>
                        </TabContent>
                    </div>
                </Page>
                : <div></div>}
        </React.Fragment>
    );
}

export default InstructionsCore;